import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ToastServicee } from "../../shared/toast.service";

@Component({
  selector: "app-global-toast",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./global-toast.component.html",
  styleUrls: ["./global-toast.component.css"],
})
export class GlobalToastComponent {
  toasts$ = this.toastService.toasts$;

  constructor(private toastService: ToastServicee) {}

  remove(id: number) {
    this.toastService.remove(id);
  }
}
